import styled from 'styled-components';

import { respondDown, textEllipsis } from 'styles/mixins';
import { Breakpoints, COLORS } from 'styles/style-constants';

export const Container = styled.div`
    display: flex;
    align-items: center;
    color: ${COLORS.textGray};
    max-width: 17rem;
    height: 1.7rem;

    span {
        font-size: 1.4rem;
        ${textEllipsis};
    }
`;

export const Percent = styled.div<{ $percent: number }>`
    display: flex;
    align-items: center;
    margin-left: 0.4rem;

    svg {
        margin: 0 0.4rem;
    }
    color: ${({ $percent }) => {
        if ($percent > 0) {
            return COLORS.green500;
        }

        if ($percent <= -10) {
            return COLORS.red500;
        }

        return COLORS.textGray;
    }};
`;

export const TooltipInner = styled.p`
    width: 38rem;
    white-space: pre-wrap;
    font-size: 1.4rem;
    line-height: 2rem;

    ${respondDown(Breakpoints.md)`
        width: 20rem;
    `}
`;
